var _excluded = ["caps", "variant"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button as KendoButton } from '@progress/kendo-react-buttons';
var StyledButton = styled(_ref => {
  var {
      caps,
      variant
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(KendoButton, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n    "])), props.caps && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            text-transform: uppercase;\n        "]))), props.fillMode === 'flat' && props.themeColor === 'primary' && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            color: ", ";\n        "])), props.theme.typography.link), props.variant === 'active' && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            color: ", ";\n            font-weight: bold;\n        "])), props.theme.colors.primary), props.variant === 'link' && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            padding: 0;\n\n            ", "\n\n            &:active::before,\n            &:focus::before {\n                opacity: 0;\n            }\n\n            &:hover {\n                &::before {\n                    opacity: 0;\n                }\n\n                color: ", ";\n            }\n        "])), props.selected && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                text-decoration: underline !important;\n                text-decoration-thickness: 2px !important;\n                text-underline-offset: 2px !important;\n            "]))), props.theme.typography.linkHover), props.variant === 'secondary' && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            color: ", ";\n            font-weight: 400;\n        "])), props.theme.colors.secondary)));

/**
 * The KendoReact Button provides a clickable UI functionality, and you can configure it to
 * perform any action or trigger an event. To make the Button even more user-friendly and
 * intuitive to use, you can display textual content, predefined icons, images, custom icons,
 * or render a combination of textual and image content within the Button.
 */
var Button = props => {
  var {
    caps,
    fillMode,
    themeColor,
    variant
  } = props;
  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, props, {
    caps: variant ? true : caps,
    fillMode: variant ? 'flat' : fillMode,
    themeColor: variant === 'link' ? 'primary' : themeColor
  }));
};
Button.defaultProps = {
  caps: false,
  children: undefined,
  disabled: false,
  fillMode: 'solid',
  icon: undefined,
  iconClass: undefined,
  imageAlt: undefined,
  imageUrl: undefined,
  rounded: 'medium',
  selected: false,
  shape: 'rectangle',
  size: 'medium',
  themeColor: 'base',
  togglable: false,
  variant: undefined
};
Button.propTypes = {
  /**
   * Specifies if the text of the Button should be capitalized.
   */
  caps: PropTypes.bool,
  /**
   * Represents the children that are passed to the Button.
   */
  children: PropTypes.node,
  /**
   * Specifies if the Button is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Configures the fillMode of the Button.
   * The available options are: 'solid' | 'outline' | 'flat' | 'link' |
   * null (Does not set a fillMode className)
   */
  fillMode: PropTypes.oneOf([null, 'link', 'flat', 'outline', 'solid']),
  /**
   * Defines the name for an existing icon in a KendoReact theme.
   * The icon is rendered inside the Button by a span.k-icon element.
   */
  icon: PropTypes.string,
  /**
   * Defines a CSS class—or multiple classes separated by spaces—which are
   * applied to a span element inside the Button. Allows the usage of custom icons.
   */
  iconClass: PropTypes.string,
  /**
   * Defines the alternative text of the image rendered inside the Button component.
   */
  imageAlt: PropTypes.string,
  /**
   * Defines a URL which is used as an img element inside the Button.
   * The URL can be relative or absolute. If relative, it is evaluated with
   * relation to the URL of the web page.
   */
  imageUrl: PropTypes.string,
  /**
   * Configures the roundness of the Button.
   * The available options are: 'small' | 'medium' | 'large' | 'full' |
   * null (Does not set a rounded className)
   */
  rounded: PropTypes.oneOf([null, 'small', 'medium', 'large', 'full']),
  /**
   * Sets the selected state of the Button. Can be used for controlled state.
   */
  selected: PropTypes.bool,
  /**
   * Configures the shape of the Button.
   * The available options are: 'rectangle' | 'square' | null (Does not set a shape className)
   */
  shape: PropTypes.oneOf([null, 'square', 'rectangle']),
  /**
   * Configures the size of the Button.
   * The available options are: 'small' | 'medium' | 'large' |
   * null (Does not set a size className)
   */
  size: PropTypes.oneOf([null, 'small', 'medium', 'large']),
  /**
   * Configures the themeColor of the Button.
   * The available options are: 'base' | 'primary' | 'secondary' | 'tertiary' | 'info' |
   * 'success' | 'warning' | 'error' | 'dark' | 'light' | 'inverse' |
   * null (Does not set a themeColor className)
   */
  themeColor: PropTypes.oneOf([null, 'base', 'primary', 'secondary', 'tertiary', 'info', 'success', 'warning', 'error', 'dark', 'light', 'inverse']),
  /**
   * Provides visual styling that indicates if the Button is selected.
   */
  togglable: PropTypes.bool,
  /**
   * Specifies the variant mode of the Button.
   * The possible values are: 'active' | 'link' | 'secondary'
   */
  variant: PropTypes.oneOf(['active', 'link', 'secondary'])
};
export default Button;